import { render, staticRenderFns } from "./NoRole.vue?vue&type=template&id=0e012fec&scoped=true&"
import script from "./NoRole.vue?vue&type=script&lang=js&"
export * from "./NoRole.vue?vue&type=script&lang=js&"
import style0 from "./NoRole.vue?vue&type=style&index=0&id=0e012fec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e012fec",
  null
  
)

export default component.exports